import { useEffect } from 'react';

/** 이 화면에 머무는 동안 뒤로 가기를 막습니다(시안 05 S0a′ 걷기 전환 · 시안 06 M4 탈퇴 완료) */
export function useBlockBack(active = true) {
    useEffect(() => {
        if (!active) {
            return undefined;
        }
        window.history.pushState(null, '', window.location.href);
        const stay = () => window.history.pushState(null, '', window.location.href);
        window.addEventListener('popstate', stay);
        return () => window.removeEventListener('popstate', stay);
    }, [active]);
}
